export default __webpack_public_path__ + "static/PIPG_Annual_testimonials-ddbfdca0eb5aae6c10aa0a80a93675e6.mp4";